import { useCallback, useEffect } from "react";
import { useApi, createApiHook } from "../utils/apiUtils";

const useFetchQuestions = () => {
  const { apiGet } = useApi();
  const useApiState = createApiHook([]);
  const { data, error, loading, startLoading, setResponse } = useApiState();

  const fetchQuestions = useCallback(async () => {
    startLoading();
    const response = await apiGet("/questions", "Error al obtener preguntas");
    setResponse(response);
    return response?.data;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    fetchQuestions();
  }, [fetchQuestions]);

  return { data, error, loading, refetch: fetchQuestions };
};

export default useFetchQuestions;
